var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgProducts = function SvgProducts(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.938.438-13 4.875C.75 5.75 0 6.875 0 8.124v14.063c0 1.125.625 2.187 1.625 2.687l13 6.5a2.916 2.916 0 0 0 2.688 0l13-6.5c1-.5 1.625-1.563 1.625-2.688V8.126c0-1.25-.75-2.375-1.938-2.813L17 .438c-.625-.25-1.375-.25-2.063 0ZM16 2.188l14 5.25L16 13.5 2 7.437l14-5.25ZM2 9.625l13 5.625v14.063l-13-6.5V9.624Zm15 19.688V15.25l13-5.625v13.188l-13 6.5Z",
    fill: "#5981E3"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgProducts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "c2a1d25f36b02d09ae4f4cbc01bb141a.svg";